import React from "react";
import { cn } from "@/lib/utils";

export const Skeleton = ({
    width = "100%",
    height = "1rem",
    borderRadius,
    className = "",
    testId,
}) => (
    <div
        data-testid={testId}
        className={cn("copper-skeleton", className)}
        style={{ width, height, borderRadius }}
    />
);
